import Layout from "@/layout/Layout.vue";
import { P } from "@/config/permissions";

const comptaDashboardRoutes = {
    path: "/compta-dashboard",
    name: "compta-dashboard",
    component: Layout,
    redirect: "/compta-dashboard/index",
    meta: {
        title: "Tableau de bord comptable",
        icon: "mdi:chart-box-outline",
        permissions: [P.FACTURES_ACHAT.BROWSE],
        noCache: true
    },
    children: [
        {
            path: "index",
            name: "compta-dashboard-index",
            meta: {
                title: "Tableau de bord comptable",
                icon: "mdi:chart-box-outline",
                noCache: true,
                permissions: [P.FACTURES_ACHAT.BROWSE]
            },
            component: () => import("@/views/comptaDashboard/ComptaDashboard.vue")
        }
    ]
};

export default comptaDashboardRoutes;
